export default __webpack_public_path__ + "static/geetajayanti2-4af48d8b0c9440ad66e53b943bb1dcf8.jpg";